<script lang="ts">
	import SiteHeader from '@shared/SiteHeader.svelte';
	import type { SiteConfig } from '$lib/types';

	interface Props {
		site: SiteConfig;
		pathname?: string;
	}

	let { site, pathname = '' }: Props = $props();
</script>

<SiteHeader {site} context="landing" {pathname} />
